import { render, staticRenderFns } from "./SongIndex.vue?vue&type=template&id=44f90f5e"
import script from "./SongIndex.vue?vue&type=script&lang=js"
export * from "./SongIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports